import { IRelationalItemBean } from "../beans/items";
import { RelationalActionParameter } from "../../../../domain/document/items";

export class RelationalActionTranslator {
  static toItems(beans: IRelationalItemBean[]): RelationalActionParameter[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toItem(bean));
  }

  static toItem(bean: IRelationalItemBean): RelationalActionParameter {
    return new RelationalActionParameter(
      bean.relationalActionType,
      bean.itemType,
      bean.pageKey,
      bean.objectId,
      bean.key,
      bean.subKey,
      bean.value,
      bean.operator,
      bean.name,
      bean.valueObjectPageKey,
      bean.valueObjectName,
      bean.valueObjectId,
      bean.copies,
      bean.row,
      bean.column,
    );
  }
}
